export default "__VITE_ASSET__df3e4530__"